import { render, staticRenderFns } from "./Expert2List.vue?vue&type=template&id=09ba25f1&scoped=true&"
import script from "./Expert2List.vue?vue&type=script&lang=js&"
export * from "./Expert2List.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ba25f1",
  null
  
)

export default component.exports